import React from 'react';
import CLoading from "../CLoading";

const UsuariosResecTable = ({list}) => {
  
  if(!list){
    return  <CLoading />
  }
  
  
  const listRows = list.map((r, index) => {
    

    return <tr key={r.email}>
      <td>
        {index + 1}
      </td>
      <td>
        <h4>{r.is_admin ? <i className="fa fa-admin m5R"/> : null} {r.nombre}</h4>
        <p>{r.email}</p>
      </td>
    </tr>
  })
  return (
    <>
      <h2 className="subtitle">
        <i className="fa fa-users m10R"/>
        Usuarios de Resec
      </h2>
      
      <table className="table is-striped m10T is-fullwidth">
        <thead>
        <tr>
          <th className="tdindex">#</th>
          <th>Usuario</th>
        </tr>
        </thead>
        <tbody>
        {listRows}
        </tbody>
      </table>
    </>
  );
};

export default UsuariosResecTable